import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CalendarInput from './CalendarInput';
import ActionCalendarContainer from './ActionCalendarContainer';
import { YM_OUTPUT_FORMAT } from '../../constants/calender';
import { format } from 'date-fns';

export interface YmPickerProps {
  placeholder?: string;
  className?: string;
  selectedMonth: Date | null;
  setSelectedMonth: (pickedDate: Date | null) => void;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

type CalendarContainerProps = {
  className?: string;
  children: React.ReactNode;
};

const YmPicker: React.FC<YmPickerProps> = ({
  placeholder = '月を選択',
  className,
  selectedMonth,
  setSelectedMonth,
  ref,
  onKeyDown,
}) => {
  const [open, setOpen] = useState(false);
  const [pickedMonth, setPickedMonth] = useState<Date | null>(selectedMonth);

  const handleOk = () => {
    setOpen(false);
    setSelectedMonth(pickedMonth);
  };

  return (
    <div className="d-flex">
      <DatePicker
        selected={open ? pickedMonth : selectedMonth}
        onChange={(d: Date | null) => setPickedMonth(d)}
        showMonthYearPicker
        showFullMonthYearPicker
        dateFormat={YM_OUTPUT_FORMAT}
        locale="ja"
        open={open}
        shouldCloseOnSelect={false}
        onClickOutside={() => setOpen(false)}
        onInputClick={() => setOpen(true)}
        popperPlacement="bottom"
        placeholderText={placeholder}
        renderCustomHeader={({
          date,
          decreaseYear,
          increaseYear,
          prevYearButtonDisabled,
          nextYearButtonDisabled,
        }) => (
          <div className="rdp-header">
            <button
              type="button"
              className="react-datepicker__navigation react-datepicker__navigation--previous"
              onClick={decreaseYear}
              disabled={prevYearButtonDisabled}
            >
              <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
                ‹
              </span>
            </button>

            <div className="rdp-header-label">{format(date, 'yyyy年')}</div>

            <button
              type="button"
              className="react-datepicker__navigation react-datepicker__navigation--next"
              onClick={increaseYear}
              disabled={nextYearButtonDisabled}
            >
              <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
                ›
              </span>
            </button>
          </div>
        )}
        customInput={
          <CalendarInput
            placeholder={placeholder}
            value={selectedMonth ? format(selectedMonth, 'yyyy/MM') : ''}
            onClick={() => setOpen(true)}
          />
        }
        calendarContainer={(p: CalendarContainerProps) => (
          <ActionCalendarContainer
            {...p}
            className={`${p.className ?? ''} rdp-with-footer`}
            onOk={handleOk}
            onCancel={() => setOpen(false)}
          >
            {p.children}
          </ActionCalendarContainer>
        )}
        className={`form-control text-center ${className ?? ''}`}
      />
      <button
        className="input-group-text"
        onClick={() => setOpen(true)}
        ref={ref}
        onKeyDown={onKeyDown}
      >
        📅
      </button>
    </div>
  );
};

export default YmPicker;
